"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangePicker = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));
var _format = require("../../../utils/dates/format");
var _classnames = _interopRequireDefault(require("classnames"));
require("react-datepicker/dist/react-datepicker.css");
var _dateRangePickerModule = _interopRequireDefault(require("./date-range-picker.module.scss"));
var _enGB = _interopRequireDefault(require("date-fns/locale/en-GB"));
var _dateFns = require("date-fns");
var _DateRangeInput = require("./date-range-input/DateRangeInput");
var _Presets = require("./presets/Presets");
var _useWindowSize2 = require("../../../hooks/useWindowSize/useWindowSize");
var _noop = require("../../../utils/noop");
var _CalendarHeader = require("../calendar-header/CalendarHeader");
(0, _reactDatepicker.registerLocale)('en', _enGB.default);
var MIN_WIDTH_FOR_TWO_MONTHS = 860;
var DateRangePicker = function DateRangePicker(_ref) {
  var _classNames2;
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    onDateChange = _ref.onDateChange,
    className = _ref.className,
    disabled = _ref.disabled,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'bottom' : _ref$position,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    startDateId = _ref.startDateId,
    endDateId = _ref.endDateId,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? _noop.noop : _ref$onClose,
    initiallyOpen = _ref.initiallyOpen;
  var _useState = (0, _react.useState)(undefined),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hoveredDate = _useState2[0],
    setHoveredDate = _useState2[1];
  var startDateRef = (0, _react.useRef)();
  var endDateRef = (0, _react.useRef)();
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    width = _useWindowSize.width;
  var _useState3 = (0, _react.useState)(1),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    currentKey = _useState4[0],
    setCurrentKey = _useState4[1];
  var _useState5 = (0, _react.useState)(startDate ? startDate : undefined),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    selectedStartDate = _useState6[0],
    setStartDate = _useState6[1];
  var _useState7 = (0, _react.useState)(endDate ? endDate : undefined),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    selectedEndDate = _useState8[0],
    setEndDate = _useState8[1];
  var shouldShowSingleMonth = width < MIN_WIDTH_FOR_TWO_MONTHS;
  var _useState9 = (0, _react.useState)(startDate ? (0, _format.formatShortDate)(startDate) : undefined),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    startDateInputValue = _useState10[0],
    setStartDateInputValue = _useState10[1];
  var _useState11 = (0, _react.useState)(endDate ? (0, _format.formatShortDate)(endDate) : undefined),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    endDateInputValue = _useState12[0],
    setEndDateInputValue = _useState12[1];
  (0, _react.useEffect)(function () {
    if (initiallyOpen) {
      startDateRef.current.focus();
    }
  }, [initiallyOpen]);
  (0, _react.useEffect)(function () {
    setStartDate(startDate);
    if (startDate) {
      var formatted = (0, _format.formatShortDate)(startDate);
      setStartDateInputValue(formatted);
    } else {
      setStartDateInputValue(undefined);
    }
  }, [startDate]);
  (0, _react.useEffect)(function () {
    setEndDate(endDate);
    if (endDate) {
      var formatted = (0, _format.formatShortDate)(endDate);
      setEndDateInputValue(formatted);
    } else {
      setEndDateInputValue(undefined);
    }
  }, [endDate]);
  var renderDay = function renderDay(day, date) {
    var _classNames;
    var isLastColumn = (0, _dateFns.isLastDayOfMonth)(date) || (0, _dateFns.isSameDay)(date, (0, _dateFns.endOfWeek)(date, {
      locale: _enGB.default
    }));
    var isFirstColumn = (0, _dateFns.isFirstDayOfMonth)(date) || (0, _dateFns.isSameDay)(date, (0, _dateFns.startOfWeek)(date, {
      locale: _enGB.default
    }));
    return /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": (0, _format.formatIsoDate)(date),
      className: (0, _classnames.default)(_dateRangePickerModule.default['date-range-picker__day'], (_classNames = {}, (0, _defineProperty2.default)(_classNames, _dateRangePickerModule.default['date-range-picker__day--first-column'], isFirstColumn), (0, _defineProperty2.default)(_classNames, _dateRangePickerModule.default['date-range-picker__day--last-column'], isLastColumn), (0, _defineProperty2.default)(_classNames, _dateRangePickerModule.default['date-range-picker__day--selection-end'], !endDate && hoveredDate && (0, _dateFns.isSameDay)(date, hoveredDate)), _classNames))
    }, (0, _dateFns.getDate)(date));
  };
  var renderContainer = function renderContainer(_ref2) {
    var children = _ref2.children;
    var handleChange = function handleChange(date) {
      handleOnChange([date.startDate, date.endDate]);
    };
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": 'date-range-picker-container',
      className: _dateRangePickerModule.default['date-range-picker__container']
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _dateRangePickerModule.default['date-range-picker__months-container']
    }, children), /*#__PURE__*/_react.default.createElement(_Presets.Presets, {
      onDateChange: handleChange,
      startDate: selectedStartDate,
      endDate: selectedEndDate
    }));
  };
  var handleCalendarClose = function handleCalendarClose() {
    onClose();
  };
  var handleOnChange = function handleOnChange(dates) {
    var _dates = (0, _slicedToArray2.default)(dates, 2),
      start = _dates[0],
      end = _dates[1];
    var newStartDate = start ? start : undefined;
    var newEndDate = end ? end : undefined;
    setStartDate(newStartDate);
    setStartDateInputValue(newStartDate ? (0, _format.formatShortDate)(newStartDate) : undefined);
    setEndDateInputValue(newEndDate ? (0, _format.formatShortDate)(newEndDate) : undefined);
    setEndDate(newEndDate);
    onDateChange({
      startDate: newStartDate,
      endDate: newEndDate
    });
    if (newStartDate && newEndDate || !newStartDate && !newEndDate) {
      setCurrentKey(currentKey + 1);
    }
  };
  var onChangeRaw = function onChangeRaw(e) {
    if (e.currentTarget.value !== undefined) {
      if (e.currentTarget.value === '') {
        setStartDateInputValue('');
        setEndDateInputValue('');
        setStartDate(undefined);
        setEndDate(undefined);
      } else {
        var splittedValue = e.currentTarget.value.split(' - ');
        var parsedStart = (0, _dateFns.parse)(splittedValue[0], _format.shortDateFormat, new Date());
        var parsedEnd = (0, _dateFns.parse)(splittedValue[1], _format.shortDateFormat, new Date());
        if (splittedValue[0].length === _format.shortDateFormat.length && (0, _dateFns.isValid)(parsedStart) && ((0, _dateFns.isSameDay)(parsedStart, parsedEnd) || (0, _dateFns.isBefore)(parsedStart, parsedEnd))) {
          setStartDate(parsedStart);
        }
        if (splittedValue[1].length === _format.shortDateFormat.length && (0, _dateFns.isValid)(parsedEnd) && ((0, _dateFns.isSameDay)(parsedStart, parsedEnd) || (0, _dateFns.isBefore)(parsedStart, parsedEnd))) {
          setEndDate(parsedEnd);
        }
        setStartDateInputValue(splittedValue[0]);
        setEndDateInputValue(splittedValue[1]);
      }
    }
  };
  var syncPickerValues = function syncPickerValues() {
    setStartDateInputValue(selectedStartDate ? (0, _format.formatShortDate)(selectedStartDate) : '');
    setEndDateInputValue(selectedEndDate ? (0, _format.formatShortDate)(selectedEndDate) : '');
  };
  var handleIconClick = function handleIconClick() {
    var calendar = document.querySelector('[data-testid="date-range-picker-container"]');
    if (calendar) {
      syncPickerValues();
      setCurrentKey(currentKey + 1);
      onClose();
    } else {
      startDateRef.current.focus();
    }
  };
  var _onClickOutside = function onClickOutside() {
    syncPickerValues();
    setCurrentKey(currentKey + 1);
    onClose();
  };
  var onClearClick = function onClearClick() {
    setCurrentKey(currentKey + 1);
    onClose();
  };
  var filterDates = function filterDates(date) {
    if (selectedStartDate && !endDate) {
      return (0, _dateFns.isSameDay)(date, selectedStartDate) || (0, _dateFns.isAfter)(date, selectedStartDate);
    } else {
      return true;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_dateRangePickerModule.default['date-range-picker'], className, (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, _dateRangePickerModule.default['date-range-picker--disabled'], disabled), (0, _defineProperty2.default)(_classNames2, _dateRangePickerModule.default['date-range-picker--top'], position === 'top'), (0, _defineProperty2.default)(_classNames2, _dateRangePickerModule.default['date-range-picker--small'], small), (0, _defineProperty2.default)(_classNames2, _dateRangePickerModule.default['date-range-picker--inline'], inline), _classNames2))
  }, /*#__PURE__*/_react.default.createElement(_reactDatepicker.default, {
    key: currentKey,
    locale: "en",
    autocomplete: false,
    value: "".concat(startDateInputValue, " - ").concat(endDateInputValue),
    selected: selectedStartDate,
    startDate: selectedStartDate,
    endDate: selectedEndDate,
    selectsRange: true,
    monthsShown: shouldShowSingleMonth ? 1 : 2,
    onCalendarClose: handleCalendarClose,
    onChange: handleOnChange,
    onChangeRaw: onChangeRaw,
    dateFormat: _format.shortDateFormat,
    showPopperArrow: false,
    filterDate: filterDates,
    renderDayContents: renderDay,
    renderCustomHeader: shouldShowSingleMonth ? _CalendarHeader.CustomHeader : _CalendarHeader.CustomTwoMonthsHeader,
    calendarContainer: renderContainer,
    onClickOutside: function onClickOutside() {
      return _onClickOutside();
    },
    customInputRef: 'customRef',
    customInput: /*#__PURE__*/_react.default.createElement(_DateRangeInput.DateRangeInput, {
      inline: inline,
      small: small,
      startDateId: startDateId,
      endDateId: endDateId,
      startDateRef: startDateRef,
      endDateRef: endDateRef,
      error: error,
      onDateChange: handleOnChange,
      onIconClick: handleIconClick,
      onClearClick: onClearClick,
      startDateValue: startDateInputValue,
      endDateValue: endDateInputValue
    })
    // Use this PR when it is released instead of this hack
    // https://github.com/Hacker0x01/react-datepicker/pull/3595
    // @ts-ignore
    ,
    onDayMouseEnter: function onDayMouseEnter(day) {
      setHoveredDate(day);
    },
    disabled: disabled
  }));
};
exports.DateRangePicker = DateRangePicker;